import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/search.svg'
import _imports_1 from '@/assets/icons/add.svg'
import _imports_2 from '@/assets/icons/addaddonenabled.svg'
import _imports_3 from '@/assets/icons/addaddondisabled.svg'
import _imports_4 from '@/assets/icons/deladdonenabled.svg'
import _imports_5 from '@/assets/icons/deladdondisabled.svg'
import _imports_6 from '@/assets/icons/deletedisabled.svg'
import _imports_7 from '@/assets/icons/delete.svg'


const _hoisted_1 = {
  class: "controltextstyle",
  style: {"margin-top":"3rem"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h5", { class: "font-bold-24" }, "Assigned Users", -1)
const _hoisted_3 = { class: "utils btm-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"25px"},
  alt: "searchimg",
  title: "searchimg"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {"width":"40px"},
  alt: "Assign product",
  title: "Click to assign the product"
}, null, -1)
const _hoisted_6 = {
  key: 0,
  src: _imports_2,
  style: {"width":"40px"},
  alt: "Add add-on",
  title: "Click to add add-ons"
}
const _hoisted_7 = {
  key: 1,
  src: _imports_3,
  style: {"width":"40px"},
  alt: "Add add-on disabled",
  title: "Click to add add-ons"
}
const _hoisted_8 = {
  key: 0,
  src: _imports_4,
  style: {"width":"40px"},
  alt: "Delete add-on",
  title: "Click to delete add-ons"
}
const _hoisted_9 = {
  key: 1,
  src: _imports_5,
  style: {"width":"40px"},
  alt: "Delete add-on disabled",
  title: "Click to delete add-ons"
}
const _hoisted_10 = {
  key: 0,
  src: _imports_6,
  style: {"width":"40px"},
  alt: "Delete assigned users disabled",
  title: "Click to remove assigned users"
}
const _hoisted_11 = {
  key: 1,
  src: _imports_7,
  style: {"width":"40px"},
  alt: "Delete assigned users",
  title: "Click to remove assigned users"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_AssignUsersModal = _resolveComponent("AssignUsersModal")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_AssignAddonModal = _resolveComponent("AssignAddonModal")!
  const _component_RemoveAddonsModal = _resolveComponent("RemoveAddonsModal")!
  const _component_RemoveEntitlementsModal = _resolveComponent("RemoveEntitlementsModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.showOptions)
        ? (_openBlock(), _createBlock(_component_el_input, {
            key: 0,
            id: "productsearch",
            modelValue: _ctx.prdSearchVal,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.prdSearchVal) = $event)),
            placeholder: "Search",
            type: "search",
            debounce: "1000",
            class: "rightmargin inpstyle"
          }, {
            suffix: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      _createVNode(_component_el_button, {
        plain: "",
        class: "delbtn",
        onClick: _ctx.assignUsers,
        id: "assignprodtouser"
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["onClick"]),
      (_ctx.showOptions)
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            plain: "",
            class: "delbtn",
            onClick: _ctx.assignAddon,
            id: "addignaddon",
            disabled: !_ctx.enablebuttons
          }, {
            default: _withCtx(() => [
              (_ctx.enablebuttons)
                ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                : _createCommentVNode("", true),
              (!_ctx.enablebuttons)
                ? (_openBlock(), _createElementBlock("img", _hoisted_7))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["onClick", "disabled"]))
        : _createCommentVNode("", true),
      (_ctx.showOptions)
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 2,
            plain: "",
            class: "delbtn",
            onClick: _ctx.removeAddon,
            id: "removeaddon",
            disabled: !_ctx.enablebuttons && _ctx.DisableDeleteAddon
          }, {
            default: _withCtx(() => [
              (_ctx.enablebuttons && !_ctx.DisableDeleteAddon)
                ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                : _createCommentVNode("", true),
              (_ctx.DisableDeleteAddon)
                ? (_openBlock(), _createElementBlock("img", _hoisted_9))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["onClick", "disabled"]))
        : _createCommentVNode("", true),
      (_ctx.showOptions)
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 3,
            plain: "",
            class: "delbtn",
            onClick: _ctx.removeEntitlements,
            id: "removeentitlement",
            disabled: !_ctx.enablebuttons
          }, {
            default: _withCtx(() => [
              (!_ctx.enablebuttons)
                ? (_openBlock(), _createElementBlock("img", _hoisted_10))
                : _createCommentVNode("", true),
              (_ctx.enablebuttons)
                ? (_openBlock(), _createElementBlock("img", _hoisted_11))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["onClick", "disabled"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_el_drawer, {
      modelValue: _ctx.showAdduser,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showAdduser) = $event)),
      direction: "rtl",
      size: "40%",
      "destroy-on-close": "",
      "close-on-press-escape": false,
      "close-on-click-modal": false,
      wrapperClosable: false
    }, {
      default: _withCtx(() => [
        (_ctx.showAssignUserModal)
          ? (_openBlock(), _createBlock(_component_AssignUsersModal, {
              key: 0,
              showheading: true
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_drawer, {
      modelValue: _ctx.showAssignAddon,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showAssignAddon) = $event)),
      direction: "rtl",
      size: "40%",
      "destroy-on-close": "",
      "close-on-press-escape": false,
      "close-on-click-modal": false,
      wrapperClosable: false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AssignAddonModal)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_drawer, {
      modelValue: _ctx.showRemoveAddonsList,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showRemoveAddonsList) = $event)),
      direction: "rtl",
      size: "40%",
      "destroy-on-close": "",
      "close-on-press-escape": false,
      "close-on-click-modal": false,
      wrapperClosable: false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_RemoveAddonsModal)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_drawer, {
      modelValue: _ctx.showRemoveEntitlements,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showRemoveEntitlements) = $event)),
      direction: "rtl",
      size: "40%",
      "destroy-on-close": "",
      "close-on-press-escape": false,
      "close-on-click-modal": false,
      wrapperClosable: false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_RemoveEntitlementsModal)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}